const actions = {
  updateUserInfo({ commit }, payload) {
    console.log(payload);
    commit("UPDATE_USER_INFO", payload);
  },
};

export default actions;
